import type React from 'react';
import styles from './TotalPrice.module.scss';
import FormatPrice from '../../../general/Format/FormatPrice';
import Translation from '../../../general/Translation/Translation';
import type { Price } from '../../../../ssr/src/Outlet/ShoppingCart/ShoppingCartSchema';

export interface TotalPriceProps {
  price: Price;
}

const TotalPrice: React.FC<TotalPriceProps> = ({ price }) => (
  <div className={styles.TotalPrice}>
    <p className={styles.TotalPrice__header}>
      <Translation
        pageString="account"
        stringId="totalPrice"
      />
    </p>
    <p
      className={styles.TotalPrice__text}
      translate="no"
    >
      <FormatPrice price={price} />
    </p>
  </div>
);

export default TotalPrice;
